import { useState } from 'react';
import { format } from 'date-fns';
import { Calendar } from '@/components/ui/calendar';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Filter } from 'lucide-react';
import { useVisits } from '../hooks/useVisits';
import { VisitList } from './VisitList';
import { VisitFilters } from './VisitFilters';

export function VisitCalendar() {
  const [date, setDate] = useState<Date>(new Date());
  const [showFilters, setShowFilters] = useState(false);
  const { data: visits, isLoading } = useVisits({ date });

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-foreground">Visit Calendar</h1>
        <Button 
          variant="outline" 
          size="sm"
          onClick={() => setShowFilters(true)}
        >
          <Filter className="h-4 w-4 mr-2" />
          Filters
        </Button>
      </div>

      <div className="grid gap-6 lg:grid-cols-[300px,1fr]">
        <Card className="border-0 shadow-md h-fit">
          <CardHeader className="border-b bg-muted/50">
            <CardTitle className="text-foreground">Calendar</CardTitle>
          </CardHeader>
          <CardContent className="p-4">
            <Calendar
              mode="single"
              selected={date}
              onSelect={(date) => date && setDate(date)}
              className="rounded-md border"
            />
          </CardContent>
        </Card>

        <Card className="border-0 shadow-md">
          <CardHeader className="border-b bg-muted/50">
            <CardTitle className="text-foreground">
              Visits for {format(date, 'MMMM d, yyyy')}
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6">
            <VisitList 
              date={date}
              isLoading={isLoading}
              visits={visits || []}
            />
          </CardContent>
        </Card>
      </div>
      
      <VisitFilters
        open={showFilters}
        onOpenChange={setShowFilters}
      />
    </div>
  );
}
